import { getOwner } from '@ember/application';
import { later } from '@ember/runloop';

const MAX_ITERATIONS = 5;

const getModalController = (scope) => {
  return getOwner(scope).lookup('controller:application');
};

const showNextModalWithCircuitBreaker = (scope, name, data, count = 1) => {
  if (count > MAX_ITERATIONS) {
    const errorTracker = getOwner(scope).lookup('service:error-tracker');
    errorTracker.error(`Failed to show {{${name}}} modal after ${MAX_ITERATIONS} attempts`, scope);
    return;
  }

  const applicationController = getModalController(scope);

  // trying to open modal when one already open
  if (applicationController.modalComponent) {
    applicationController.closeModal();

    later(null, () => showNextModalWithCircuitBreaker(scope, name, data, count + 1), 500);
    return;
  }

  // display the modal
  applicationController.openModal(name, data);
};

export const showNextModal = (scope, name, data) => {
  showNextModalWithCircuitBreaker(scope, name, data);
};

export const showModal = (scope, name, data) => {
  showNextModalWithCircuitBreaker(scope, name, data);
};

export const closeModal = (scope) => {
  getModalController(scope).closeModal();
};
